/**
 * Owner: Masa Bayu
 * File: library-reader-launch.ts
 * Date:Time: 2026-09-15 23:21
 * Description: T4 reader launch boundary — intent only, no QXReader execution.
 */
import { authorizeReaderLaunch, } from './entitlement-boundary';
import { libraryItemAllowsReaderLaunchIntent } from './library-item';
import { assertT4E1SecurityIntact } from './library-security';
/**
 * Authorize a Reader launch intent from a library item.
 * Never executes QXReader — T5 owns runtime.
 */
export function authorizeLibraryReaderLaunch(input) {
    assertT4E1SecurityIntact();
    if (input.entitlement.entitlementId !== input.item.entitlementId) {
        return Object.freeze({
            allowed: false,
            reason: 'Entitlement must match library item for launch intent',
            libraryItemId: input.item.libraryItemId,
            publicationId: input.item.publicationId,
            executesReader: false,
        });
    }
    if (!libraryItemAllowsReaderLaunchIntent(input.item)) {
        return Object.freeze({
            allowed: false,
            reason: `Library state "${input.item.state}" does not permit launch intent`,
            libraryItemId: input.item.libraryItemId,
            publicationId: input.item.publicationId,
            executesReader: false,
        });
    }
    const auth = authorizeReaderLaunch({
        sessionAuthenticated: input.sessionAuthenticated,
        accountId: input.accountId,
        publicationBound: input.item.qxpPublicationRef !== null,
        entitlement: input.entitlement,
        requireFullAccess: input.allowPreviewLaunch === true ? false : true,
    });
    return Object.freeze({
        allowed: auth.allowed,
        reason: auth.allowed
            ? 'Library launch intent authorized — QXReader execution remains T5'
            : auth.reason,
        libraryItemId: input.item.libraryItemId,
        publicationId: input.item.publicationId,
        executesReader: false,
    });
}
//# sourceMappingURL=library-reader-launch.js.map